/* import __COLOCATED_TEMPLATE__ from './slot.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();